import { isEmpty } from "@swiggy-private/js-utils";
import { OrderData } from "@swiggy-private/payment-types";
import { isValidNumber } from "@swiggy-private/core-ui";

const sumItemQuantities = (items: OrderData["orderItems"] = []) => {
    return items.reduce((acc, item) => {
        if (isEmpty(item) || !isValidNumber(item?.quantity)) {
            return acc;
        }
        return acc + Number(item?.quantity);
    }, 0);
};

export const calculateItemCountForOrder = (
    orderItems: OrderData["orderItems"] = [],
    childOrders: OrderData["childOrders"] = [],
) => {
    const itemCount = sumItemQuantities(orderItems);
    if (itemCount > 0) {
        return itemCount;
    }

    // we need to sum the item quantities for the child orders
    // in MRO we will have child orders with orderItems instead of parent level orderItems
    const childOrderItemCount = (childOrders as Array<{ orderItems?: OrderData["orderItems"] }>).reduce(
        (acc, child) => {
            if (isEmpty(child) || isEmpty(child?.orderItems)) {
                return acc;
            }
            return acc + sumItemQuantities(child?.orderItems);
        },
        0,
    );

    return childOrderItemCount;
};
